<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('上门服务.服务名称')">
                <a-input v-model="queryParam.serviceName" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('上门服务.服务分类')">
                <a-tree-select v-model="queryParam.categoryId" style="width: 100%"
                               :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" 
                               :tree-data="categoryOptions" 
                               :placeholder="$t('通用.输入.请选择')+$t('上门服务.服务分类')"
                               :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
                               tree-default-expand-all allow-clear>
                </a-tree-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('上门服务.是否推荐')">
                <a-select v-model="queryParam.isRecommend" allowClear style="width: 100%">
                  <a-select-option v-for="(item, index) in customDict.TFEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('上门服务.状态')">
                <a-select v-model="queryParam.status" allowClear style="width: 100%">
                  <a-select-option v-for="(item, index) in customDict.OnOffEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd()" v-hasPermi="['homeservice:service:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['homeservice:service:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
      </div>

      <!-- 数据表格 -->
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="picture" slot-scope="text, record">
          <img v-if="record.picture" :src="record.picture" style="width:60px;height:60px;" @click="handlePreview(record.picture)" alt=""/>
        </template>
        <span slot="cityNames" slot-scope="text, record">
          {{ record.cityNames || $t('上门服务.全国') }}
        </span>
        <span slot="isRecommend" slot-scope="text, record">
          <a-switch :checked="record.isRecommend" @change="(checked) => onRecommendChange(record, checked)" />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch :checked="record.status === 1" @change="(checked) => onStatusChange(record, checked)" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleUpdate(record)" v-hasPermi="['homeservice:service:edit']">
            <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['homeservice:service:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <!-- 图片预览 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewCancel">
      <img alt="preview" style="width: 100%" :src="previewUrl" />
    </a-modal>

    <!-- 新增/编辑表单 -->
    <create-form ref="createForm" @ok="getList" />
  </page-header-wrapper>
</template>

<script>
import { pageService, delService, updateService } from '@/api/homeservice/service'
import { listCategory } from '@/api/homeservice/category'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'

export default {
  name: 'HomeService',
  mixins: [tableMixin],
  components: { CreateForm },
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      selectedRowKeys: [],
      multiple: true,
      categoryOptions: [],
      previewVisible: false,
      previewUrl: '',
      queryParam: {
        serviceName: undefined,
        categoryId: undefined,
        isRecommend: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('上门服务.服务名称'), dataIndex: 'serviceName', ellipsis: true },
        { title: this.$t('上门服务.服务主图'), dataIndex: 'picture', scopedSlots: { customRender: 'picture' }, width: 100 },
        { title: this.$t('上门服务.服务分类'), dataIndex: 'categoryName', width: 120 },
        { title: this.$t('上门服务.归属城市'), dataIndex: 'cityNames', scopedSlots: { customRender: 'cityNames' }, width: 180, ellipsis: true },
        { title: this.$t('上门服务.服务价格'), dataIndex: 'price', width: 100 },
        { title: this.$t('上门服务.价格单位'), dataIndex: 'priceUnit', width: 80 },
        { title: this.$t('上门服务.是否推荐'), dataIndex: 'isRecommend', scopedSlots: { customRender: 'isRecommend' }, width: 100 },
        { title: this.$t('上门服务.状态'), dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 100 },
        { title: this.$t('上门服务.排序'), dataIndex: 'sort', width: 80 },
        { title: this.$t('上门服务.创建时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, width: 150 },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, width: 150 }
      ]
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  created() {
    this.getList()
    this.getCategoryList()
  },
  methods: {
    getList() {
      this.loading = true
      pageService(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getCategoryList() {
      listCategory({}).then(response => {
        this.categoryOptions = this.handleTree(response.data, 'id', 'parentId')
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { pageNum: 1, pageSize: 10 }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.multiple = !selectedRowKeys.length
    },
    handlePreview(url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    previewCancel() {
      this.previewVisible = false
    },
    onRecommendChange(record, checked) {
      updateService({ id: record.id, isRecommend: checked }).then(() => {
        this.$message.success(this.$t('通用.文本.修改成功'))
        this.getList()
      })
    },
    onStatusChange(record, checked) {
      updateService({ id: record.id, status: checked ? 1 : 0 }).then(() => {
        this.$message.success(this.$t('通用.文本.修改成功'))
        this.getList()
      })
    },
    handleAdd() {
      this.$refs.createForm.handleAdd()
    },
    handleUpdate(row) {
      this.$refs.createForm.handleUpdate(row)
    },
    handleDelete(row) {
      const ids = row.id || this.selectedRowKeys
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk: () => {
          const data = (Array.isArray(ids) ? ids : [ids]).map(id => ({ id }))
          return delService(data).then(() => {
            this.selectedRowKeys = []
            this.getList()
            this.$message.success(this.$t('通用.文本.删除成功'))
          })
        }
      })
    }
  }
}
</script>
